/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CastaiAuditV2AuditEvent } from '../models';
// @ts-ignore
import type { CastaiAuditV2GetAuditHistogramResponse } from '../models';
// @ts-ignore
import type { CastaiAuditV2GetAuditStatsResponse } from '../models';
// @ts-ignore
import type { CastaiAuditV2GetRelatedAuditEventsResponse } from '../models';
// @ts-ignore
import type { CastaiAuditV2ListAuditEventsResponse } from '../models';
/**
 * AuditV2APIApi - axios parameter creator
 * @export
 */
export const AuditV2APIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetAuditEvent returns a specific audit event.
         * @param {string} id The audit event record ID.
         * @param {string} recordedAt When the event was recorded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetAuditEvent: async (id: string, recordedAt: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('auditV2APIGetAuditEvent', 'id', id)
            // verify required parameter 'recordedAt' is not null or undefined
            assertParamExists('auditV2APIGetAuditEvent', 'recordedAt', recordedAt)
            const localVarPath = `/v2/audit/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (recordedAt !== undefined) {
                localVarQueryParameter['recordedAt'] = (recordedAt as any instanceof Date) ?
                    (recordedAt as any).toISOString() :
                    recordedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetAuditHistogram returns a histogram of audit events bucketed by time and grouped by severity.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The date and time to query to. Defaults to now if not set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {number} [numBuckets] Number of histogram buckets to return. Defaults to 100, capped at 1000.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetAuditHistogram: async (fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, numBuckets?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/audit/histogram`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterClusters) {
                localVarQueryParameter['filter.clusters'] = filterClusters;
            }

            if (filterDomains) {
                localVarQueryParameter['filter.domains'] = filterDomains;
            }

            if (filterResources) {
                localVarQueryParameter['filter.resources'] = filterResources;
            }

            if (filterActions) {
                localVarQueryParameter['filter.actions'] = filterActions;
            }

            if (filterSources) {
                localVarQueryParameter['filter.sources'] = filterSources;
            }

            if (filterSeverity) {
                localVarQueryParameter['filter.severity'] = filterSeverity;
            }

            if (numBuckets !== undefined) {
                localVarQueryParameter['numBuckets'] = numBuckets;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetAuditStats returns statistics for audit events matching the criteria set by filter.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The date and time to query to. Defaults to now if not set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetAuditStats: async (fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/audit/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterClusters) {
                localVarQueryParameter['filter.clusters'] = filterClusters;
            }

            if (filterDomains) {
                localVarQueryParameter['filter.domains'] = filterDomains;
            }

            if (filterResources) {
                localVarQueryParameter['filter.resources'] = filterResources;
            }

            if (filterActions) {
                localVarQueryParameter['filter.actions'] = filterActions;
            }

            if (filterSources) {
                localVarQueryParameter['filter.sources'] = filterSources;
            }

            if (filterSeverity) {
                localVarQueryParameter['filter.severity'] = filterSeverity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetEnterpriseAuditEvent returns a specific audit event within the enterprise organization, including events from its child organizations.
         * @param {string} id The audit event record ID.
         * @param {string} recordedAt When the event was recorded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetEnterpriseAuditEvent: async (id: string, recordedAt: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('auditV2APIGetEnterpriseAuditEvent', 'id', id)
            // verify required parameter 'recordedAt' is not null or undefined
            assertParamExists('auditV2APIGetEnterpriseAuditEvent', 'recordedAt', recordedAt)
            const localVarPath = `/v2/audit/enterprise/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (recordedAt !== undefined) {
                localVarQueryParameter['recordedAt'] = (recordedAt as any instanceof Date) ?
                    (recordedAt as any).toISOString() :
                    recordedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetEnterpriseAuditHistogram returns a histogram of audit events for the enterprise organization, including events from its child organizations.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The date and time to query to. Defaults to now if not set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {number} [numBuckets] Number of histogram buckets to return. Defaults to 100, capped at 1000.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetEnterpriseAuditHistogram: async (fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, numBuckets?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/audit/enterprise/histogram`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterClusters) {
                localVarQueryParameter['filter.clusters'] = filterClusters;
            }

            if (filterDomains) {
                localVarQueryParameter['filter.domains'] = filterDomains;
            }

            if (filterResources) {
                localVarQueryParameter['filter.resources'] = filterResources;
            }

            if (filterActions) {
                localVarQueryParameter['filter.actions'] = filterActions;
            }

            if (filterSources) {
                localVarQueryParameter['filter.sources'] = filterSources;
            }

            if (filterSeverity) {
                localVarQueryParameter['filter.severity'] = filterSeverity;
            }

            if (numBuckets !== undefined) {
                localVarQueryParameter['numBuckets'] = numBuckets;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetEnterpriseAuditStats returns statistics for audit events for the enterprise organization, including events from its child organizations.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The date and time to query to. Defaults to now if not set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetEnterpriseAuditStats: async (fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/audit/enterprise/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterClusters) {
                localVarQueryParameter['filter.clusters'] = filterClusters;
            }

            if (filterDomains) {
                localVarQueryParameter['filter.domains'] = filterDomains;
            }

            if (filterResources) {
                localVarQueryParameter['filter.resources'] = filterResources;
            }

            if (filterActions) {
                localVarQueryParameter['filter.actions'] = filterActions;
            }

            if (filterSources) {
                localVarQueryParameter['filter.sources'] = filterSources;
            }

            if (filterSeverity) {
                localVarQueryParameter['filter.severity'] = filterSeverity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetEnterpriseRelatedAuditEvents returns events related to the specified event within the enterprise organization, including events from its child organizations.
         * @param {string} id The audit event record ID.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [recordedAt] When the event was recorded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetEnterpriseRelatedAuditEvents: async (id: string, pageLimit?: string, pageCursor?: string, recordedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('auditV2APIGetEnterpriseRelatedAuditEvents', 'id', id)
            const localVarPath = `/v2/audit/enterprise/events/{id}/correlated`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (recordedAt !== undefined) {
                localVarQueryParameter['recordedAt'] = (recordedAt as any instanceof Date) ?
                    (recordedAt as any).toISOString() :
                    recordedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetRelatedAuditEvents returns events related to the specified event.
         * @param {string} id The audit event record ID.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [recordedAt] When the event was recorded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetRelatedAuditEvents: async (id: string, pageLimit?: string, pageCursor?: string, recordedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('auditV2APIGetRelatedAuditEvents', 'id', id)
            const localVarPath = `/v2/audit/events/{id}/correlated`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (recordedAt !== undefined) {
                localVarQueryParameter['recordedAt'] = (recordedAt as any instanceof Date) ?
                    (recordedAt as any).toISOString() :
                    recordedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ListAuditEvents returns a list of audit events.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The maximum date and time to query to. Defaults to now if from_date is set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {string} [sortField] Name of the field you want to sort
         * @param {AuditV2APIListAuditEventsSortOrderEnum} [sortOrder] The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
         * @param {boolean} [includeBody] Whether to include the event body (full JSON payload b64 encoded string) for each returned event. When true, the effective page limit is capped at 25 due to payload sizes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIListAuditEvents: async (pageLimit?: string, pageCursor?: string, fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, sortField?: string, sortOrder?: AuditV2APIListAuditEventsSortOrderEnum, includeBody?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/audit/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterClusters) {
                localVarQueryParameter['filter.clusters'] = filterClusters;
            }

            if (filterDomains) {
                localVarQueryParameter['filter.domains'] = filterDomains;
            }

            if (filterResources) {
                localVarQueryParameter['filter.resources'] = filterResources;
            }

            if (filterActions) {
                localVarQueryParameter['filter.actions'] = filterActions;
            }

            if (filterSources) {
                localVarQueryParameter['filter.sources'] = filterSources;
            }

            if (filterSeverity) {
                localVarQueryParameter['filter.severity'] = filterSeverity;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (includeBody !== undefined) {
                localVarQueryParameter['includeBody'] = includeBody;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ListEnterpriseAuditEvents returns a list of audit events for the enterprise organization, including events from its child organizations.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The maximum date and time to query to. Defaults to now if from_date is set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {string} [sortField] Name of the field you want to sort
         * @param {AuditV2APIListEnterpriseAuditEventsSortOrderEnum} [sortOrder] The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
         * @param {boolean} [includeBody] Whether to include the event body (full JSON payload b64 encoded string) for each returned event. When true, the effective page limit is capped at 25 due to payload sizes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIListEnterpriseAuditEvents: async (pageLimit?: string, pageCursor?: string, fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, sortField?: string, sortOrder?: AuditV2APIListEnterpriseAuditEventsSortOrderEnum, includeBody?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/audit/enterprise/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterClusters) {
                localVarQueryParameter['filter.clusters'] = filterClusters;
            }

            if (filterDomains) {
                localVarQueryParameter['filter.domains'] = filterDomains;
            }

            if (filterResources) {
                localVarQueryParameter['filter.resources'] = filterResources;
            }

            if (filterActions) {
                localVarQueryParameter['filter.actions'] = filterActions;
            }

            if (filterSources) {
                localVarQueryParameter['filter.sources'] = filterSources;
            }

            if (filterSeverity) {
                localVarQueryParameter['filter.severity'] = filterSeverity;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (includeBody !== undefined) {
                localVarQueryParameter['includeBody'] = includeBody;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditV2APIApi - functional programming interface
 * @export
 */
export const AuditV2APIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditV2APIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary GetAuditEvent returns a specific audit event.
         * @param {string} id The audit event record ID.
         * @param {string} recordedAt When the event was recorded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditV2APIGetAuditEvent(id: string, recordedAt: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV2AuditEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditV2APIGetAuditEvent(id, recordedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditV2APIApi.auditV2APIGetAuditEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetAuditHistogram returns a histogram of audit events bucketed by time and grouped by severity.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The date and time to query to. Defaults to now if not set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {number} [numBuckets] Number of histogram buckets to return. Defaults to 100, capped at 1000.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditV2APIGetAuditHistogram(fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, numBuckets?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV2GetAuditHistogramResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditV2APIGetAuditHistogram(fromDate, toDate, filterSearch, filterClusters, filterDomains, filterResources, filterActions, filterSources, filterSeverity, numBuckets, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditV2APIApi.auditV2APIGetAuditHistogram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetAuditStats returns statistics for audit events matching the criteria set by filter.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The date and time to query to. Defaults to now if not set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditV2APIGetAuditStats(fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV2GetAuditStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditV2APIGetAuditStats(fromDate, toDate, filterSearch, filterClusters, filterDomains, filterResources, filterActions, filterSources, filterSeverity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditV2APIApi.auditV2APIGetAuditStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetEnterpriseAuditEvent returns a specific audit event within the enterprise organization, including events from its child organizations.
         * @param {string} id The audit event record ID.
         * @param {string} recordedAt When the event was recorded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditV2APIGetEnterpriseAuditEvent(id: string, recordedAt: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV2AuditEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditV2APIGetEnterpriseAuditEvent(id, recordedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditV2APIApi.auditV2APIGetEnterpriseAuditEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetEnterpriseAuditHistogram returns a histogram of audit events for the enterprise organization, including events from its child organizations.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The date and time to query to. Defaults to now if not set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {number} [numBuckets] Number of histogram buckets to return. Defaults to 100, capped at 1000.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditV2APIGetEnterpriseAuditHistogram(fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, numBuckets?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV2GetAuditHistogramResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditV2APIGetEnterpriseAuditHistogram(fromDate, toDate, filterSearch, filterClusters, filterDomains, filterResources, filterActions, filterSources, filterSeverity, numBuckets, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditV2APIApi.auditV2APIGetEnterpriseAuditHistogram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetEnterpriseAuditStats returns statistics for audit events for the enterprise organization, including events from its child organizations.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The date and time to query to. Defaults to now if not set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditV2APIGetEnterpriseAuditStats(fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV2GetAuditStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditV2APIGetEnterpriseAuditStats(fromDate, toDate, filterSearch, filterClusters, filterDomains, filterResources, filterActions, filterSources, filterSeverity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditV2APIApi.auditV2APIGetEnterpriseAuditStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetEnterpriseRelatedAuditEvents returns events related to the specified event within the enterprise organization, including events from its child organizations.
         * @param {string} id The audit event record ID.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [recordedAt] When the event was recorded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditV2APIGetEnterpriseRelatedAuditEvents(id: string, pageLimit?: string, pageCursor?: string, recordedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV2GetRelatedAuditEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditV2APIGetEnterpriseRelatedAuditEvents(id, pageLimit, pageCursor, recordedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditV2APIApi.auditV2APIGetEnterpriseRelatedAuditEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetRelatedAuditEvents returns events related to the specified event.
         * @param {string} id The audit event record ID.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [recordedAt] When the event was recorded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditV2APIGetRelatedAuditEvents(id: string, pageLimit?: string, pageCursor?: string, recordedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV2GetRelatedAuditEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditV2APIGetRelatedAuditEvents(id, pageLimit, pageCursor, recordedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditV2APIApi.auditV2APIGetRelatedAuditEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ListAuditEvents returns a list of audit events.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The maximum date and time to query to. Defaults to now if from_date is set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {string} [sortField] Name of the field you want to sort
         * @param {AuditV2APIListAuditEventsSortOrderEnum} [sortOrder] The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
         * @param {boolean} [includeBody] Whether to include the event body (full JSON payload b64 encoded string) for each returned event. When true, the effective page limit is capped at 25 due to payload sizes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditV2APIListAuditEvents(pageLimit?: string, pageCursor?: string, fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, sortField?: string, sortOrder?: AuditV2APIListAuditEventsSortOrderEnum, includeBody?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV2ListAuditEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditV2APIListAuditEvents(pageLimit, pageCursor, fromDate, toDate, filterSearch, filterClusters, filterDomains, filterResources, filterActions, filterSources, filterSeverity, sortField, sortOrder, includeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditV2APIApi.auditV2APIListAuditEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ListEnterpriseAuditEvents returns a list of audit events for the enterprise organization, including events from its child organizations.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The maximum date and time to query to. Defaults to now if from_date is set.
         * @param {string} [filterSearch] Plain-text search over audit event fields.
         * @param {Array<string>} [filterClusters] List of audit event cluster IDs.
         * @param {Array<string>} [filterDomains] List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
         * @param {Array<string>} [filterResources] List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
         * @param {Array<string>} [filterActions] List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
         * @param {Array<string>} [filterSources] List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
         * @param {Array<string>} [filterSeverity] List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
         * @param {string} [sortField] Name of the field you want to sort
         * @param {AuditV2APIListEnterpriseAuditEventsSortOrderEnum} [sortOrder] The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
         * @param {boolean} [includeBody] Whether to include the event body (full JSON payload b64 encoded string) for each returned event. When true, the effective page limit is capped at 25 due to payload sizes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditV2APIListEnterpriseAuditEvents(pageLimit?: string, pageCursor?: string, fromDate?: string, toDate?: string, filterSearch?: string, filterClusters?: Array<string>, filterDomains?: Array<string>, filterResources?: Array<string>, filterActions?: Array<string>, filterSources?: Array<string>, filterSeverity?: Array<string>, sortField?: string, sortOrder?: AuditV2APIListEnterpriseAuditEventsSortOrderEnum, includeBody?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV2ListAuditEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditV2APIListEnterpriseAuditEvents(pageLimit, pageCursor, fromDate, toDate, filterSearch, filterClusters, filterDomains, filterResources, filterActions, filterSources, filterSeverity, sortField, sortOrder, includeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditV2APIApi.auditV2APIListEnterpriseAuditEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditV2APIApi - factory interface
 * @export
 */
export const AuditV2APIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditV2APIApiFp(configuration)
    return {
        /**
         * 
         * @summary GetAuditEvent returns a specific audit event.
         * @param {AuditV2APIApiAuditV2APIGetAuditEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetAuditEvent(requestParameters: AuditV2APIApiAuditV2APIGetAuditEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV2AuditEvent> {
            return localVarFp.auditV2APIGetAuditEvent(requestParameters.id, requestParameters.recordedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetAuditHistogram returns a histogram of audit events bucketed by time and grouped by severity.
         * @param {AuditV2APIApiAuditV2APIGetAuditHistogramRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetAuditHistogram(requestParameters: AuditV2APIApiAuditV2APIGetAuditHistogramRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV2GetAuditHistogramResponse> {
            return localVarFp.auditV2APIGetAuditHistogram(requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, requestParameters.numBuckets, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetAuditStats returns statistics for audit events matching the criteria set by filter.
         * @param {AuditV2APIApiAuditV2APIGetAuditStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetAuditStats(requestParameters: AuditV2APIApiAuditV2APIGetAuditStatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV2GetAuditStatsResponse> {
            return localVarFp.auditV2APIGetAuditStats(requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetEnterpriseAuditEvent returns a specific audit event within the enterprise organization, including events from its child organizations.
         * @param {AuditV2APIApiAuditV2APIGetEnterpriseAuditEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetEnterpriseAuditEvent(requestParameters: AuditV2APIApiAuditV2APIGetEnterpriseAuditEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV2AuditEvent> {
            return localVarFp.auditV2APIGetEnterpriseAuditEvent(requestParameters.id, requestParameters.recordedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetEnterpriseAuditHistogram returns a histogram of audit events for the enterprise organization, including events from its child organizations.
         * @param {AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogramRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetEnterpriseAuditHistogram(requestParameters: AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogramRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV2GetAuditHistogramResponse> {
            return localVarFp.auditV2APIGetEnterpriseAuditHistogram(requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, requestParameters.numBuckets, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetEnterpriseAuditStats returns statistics for audit events for the enterprise organization, including events from its child organizations.
         * @param {AuditV2APIApiAuditV2APIGetEnterpriseAuditStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetEnterpriseAuditStats(requestParameters: AuditV2APIApiAuditV2APIGetEnterpriseAuditStatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV2GetAuditStatsResponse> {
            return localVarFp.auditV2APIGetEnterpriseAuditStats(requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetEnterpriseRelatedAuditEvents returns events related to the specified event within the enterprise organization, including events from its child organizations.
         * @param {AuditV2APIApiAuditV2APIGetEnterpriseRelatedAuditEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetEnterpriseRelatedAuditEvents(requestParameters: AuditV2APIApiAuditV2APIGetEnterpriseRelatedAuditEventsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV2GetRelatedAuditEventsResponse> {
            return localVarFp.auditV2APIGetEnterpriseRelatedAuditEvents(requestParameters.id, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.recordedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetRelatedAuditEvents returns events related to the specified event.
         * @param {AuditV2APIApiAuditV2APIGetRelatedAuditEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIGetRelatedAuditEvents(requestParameters: AuditV2APIApiAuditV2APIGetRelatedAuditEventsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV2GetRelatedAuditEventsResponse> {
            return localVarFp.auditV2APIGetRelatedAuditEvents(requestParameters.id, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.recordedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ListAuditEvents returns a list of audit events.
         * @param {AuditV2APIApiAuditV2APIListAuditEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIListAuditEvents(requestParameters: AuditV2APIApiAuditV2APIListAuditEventsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV2ListAuditEventsResponse> {
            return localVarFp.auditV2APIListAuditEvents(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, requestParameters.sortField, requestParameters.sortOrder, requestParameters.includeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ListEnterpriseAuditEvents returns a list of audit events for the enterprise organization, including events from its child organizations.
         * @param {AuditV2APIApiAuditV2APIListEnterpriseAuditEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditV2APIListEnterpriseAuditEvents(requestParameters: AuditV2APIApiAuditV2APIListEnterpriseAuditEventsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV2ListAuditEventsResponse> {
            return localVarFp.auditV2APIListEnterpriseAuditEvents(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, requestParameters.sortField, requestParameters.sortOrder, requestParameters.includeBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for auditV2APIGetAuditEvent operation in AuditV2APIApi.
 * @export
 * @interface AuditV2APIApiAuditV2APIGetAuditEventRequest
 */
export interface AuditV2APIApiAuditV2APIGetAuditEventRequest {
    /**
     * The audit event record ID.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetAuditEvent
     */
    readonly id: string

    /**
     * When the event was recorded.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetAuditEvent
     */
    readonly recordedAt: string
}

/**
 * Request parameters for auditV2APIGetAuditHistogram operation in AuditV2APIApi.
 * @export
 * @interface AuditV2APIApiAuditV2APIGetAuditHistogramRequest
 */
export interface AuditV2APIApiAuditV2APIGetAuditHistogramRequest {
    /**
     * The date and time to query from.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetAuditHistogram
     */
    readonly fromDate?: string

    /**
     * The date and time to query to. Defaults to now if not set.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetAuditHistogram
     */
    readonly toDate?: string

    /**
     * Plain-text search over audit event fields.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetAuditHistogram
     */
    readonly filterSearch?: string

    /**
     * List of audit event cluster IDs.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditHistogram
     */
    readonly filterClusters?: Array<string>

    /**
     * List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditHistogram
     */
    readonly filterDomains?: Array<string>

    /**
     * List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditHistogram
     */
    readonly filterResources?: Array<string>

    /**
     * List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditHistogram
     */
    readonly filterActions?: Array<string>

    /**
     * List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditHistogram
     */
    readonly filterSources?: Array<string>

    /**
     * List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditHistogram
     */
    readonly filterSeverity?: Array<string>

    /**
     * Number of histogram buckets to return. Defaults to 100, capped at 1000.
     * @type {number}
     * @memberof AuditV2APIApiAuditV2APIGetAuditHistogram
     */
    readonly numBuckets?: number
}

/**
 * Request parameters for auditV2APIGetAuditStats operation in AuditV2APIApi.
 * @export
 * @interface AuditV2APIApiAuditV2APIGetAuditStatsRequest
 */
export interface AuditV2APIApiAuditV2APIGetAuditStatsRequest {
    /**
     * The date and time to query from.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetAuditStats
     */
    readonly fromDate?: string

    /**
     * The date and time to query to. Defaults to now if not set.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetAuditStats
     */
    readonly toDate?: string

    /**
     * Plain-text search over audit event fields.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetAuditStats
     */
    readonly filterSearch?: string

    /**
     * List of audit event cluster IDs.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditStats
     */
    readonly filterClusters?: Array<string>

    /**
     * List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditStats
     */
    readonly filterDomains?: Array<string>

    /**
     * List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditStats
     */
    readonly filterResources?: Array<string>

    /**
     * List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditStats
     */
    readonly filterActions?: Array<string>

    /**
     * List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditStats
     */
    readonly filterSources?: Array<string>

    /**
     * List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetAuditStats
     */
    readonly filterSeverity?: Array<string>
}

/**
 * Request parameters for auditV2APIGetEnterpriseAuditEvent operation in AuditV2APIApi.
 * @export
 * @interface AuditV2APIApiAuditV2APIGetEnterpriseAuditEventRequest
 */
export interface AuditV2APIApiAuditV2APIGetEnterpriseAuditEventRequest {
    /**
     * The audit event record ID.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditEvent
     */
    readonly id: string

    /**
     * When the event was recorded.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditEvent
     */
    readonly recordedAt: string
}

/**
 * Request parameters for auditV2APIGetEnterpriseAuditHistogram operation in AuditV2APIApi.
 * @export
 * @interface AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogramRequest
 */
export interface AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogramRequest {
    /**
     * The date and time to query from.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogram
     */
    readonly fromDate?: string

    /**
     * The date and time to query to. Defaults to now if not set.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogram
     */
    readonly toDate?: string

    /**
     * Plain-text search over audit event fields.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogram
     */
    readonly filterSearch?: string

    /**
     * List of audit event cluster IDs.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogram
     */
    readonly filterClusters?: Array<string>

    /**
     * List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogram
     */
    readonly filterDomains?: Array<string>

    /**
     * List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogram
     */
    readonly filterResources?: Array<string>

    /**
     * List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogram
     */
    readonly filterActions?: Array<string>

    /**
     * List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogram
     */
    readonly filterSources?: Array<string>

    /**
     * List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogram
     */
    readonly filterSeverity?: Array<string>

    /**
     * Number of histogram buckets to return. Defaults to 100, capped at 1000.
     * @type {number}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogram
     */
    readonly numBuckets?: number
}

/**
 * Request parameters for auditV2APIGetEnterpriseAuditStats operation in AuditV2APIApi.
 * @export
 * @interface AuditV2APIApiAuditV2APIGetEnterpriseAuditStatsRequest
 */
export interface AuditV2APIApiAuditV2APIGetEnterpriseAuditStatsRequest {
    /**
     * The date and time to query from.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditStats
     */
    readonly fromDate?: string

    /**
     * The date and time to query to. Defaults to now if not set.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditStats
     */
    readonly toDate?: string

    /**
     * Plain-text search over audit event fields.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditStats
     */
    readonly filterSearch?: string

    /**
     * List of audit event cluster IDs.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditStats
     */
    readonly filterClusters?: Array<string>

    /**
     * List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditStats
     */
    readonly filterDomains?: Array<string>

    /**
     * List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditStats
     */
    readonly filterResources?: Array<string>

    /**
     * List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditStats
     */
    readonly filterActions?: Array<string>

    /**
     * List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditStats
     */
    readonly filterSources?: Array<string>

    /**
     * List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseAuditStats
     */
    readonly filterSeverity?: Array<string>
}

/**
 * Request parameters for auditV2APIGetEnterpriseRelatedAuditEvents operation in AuditV2APIApi.
 * @export
 * @interface AuditV2APIApiAuditV2APIGetEnterpriseRelatedAuditEventsRequest
 */
export interface AuditV2APIApiAuditV2APIGetEnterpriseRelatedAuditEventsRequest {
    /**
     * The audit event record ID.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseRelatedAuditEvents
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseRelatedAuditEvents
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseRelatedAuditEvents
     */
    readonly pageCursor?: string

    /**
     * When the event was recorded.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetEnterpriseRelatedAuditEvents
     */
    readonly recordedAt?: string
}

/**
 * Request parameters for auditV2APIGetRelatedAuditEvents operation in AuditV2APIApi.
 * @export
 * @interface AuditV2APIApiAuditV2APIGetRelatedAuditEventsRequest
 */
export interface AuditV2APIApiAuditV2APIGetRelatedAuditEventsRequest {
    /**
     * The audit event record ID.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetRelatedAuditEvents
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetRelatedAuditEvents
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetRelatedAuditEvents
     */
    readonly pageCursor?: string

    /**
     * When the event was recorded.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIGetRelatedAuditEvents
     */
    readonly recordedAt?: string
}

/**
 * Request parameters for auditV2APIListAuditEvents operation in AuditV2APIApi.
 * @export
 * @interface AuditV2APIApiAuditV2APIListAuditEventsRequest
 */
export interface AuditV2APIApiAuditV2APIListAuditEventsRequest {
    /**
     * 
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly pageCursor?: string

    /**
     * The date and time to query from.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly fromDate?: string

    /**
     * The maximum date and time to query to. Defaults to now if from_date is set.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly toDate?: string

    /**
     * Plain-text search over audit event fields.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly filterSearch?: string

    /**
     * List of audit event cluster IDs.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly filterClusters?: Array<string>

    /**
     * List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly filterDomains?: Array<string>

    /**
     * List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly filterResources?: Array<string>

    /**
     * List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly filterActions?: Array<string>

    /**
     * List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly filterSources?: Array<string>

    /**
     * List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly filterSeverity?: Array<string>

    /**
     * Name of the field you want to sort
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly sortField?: string

    /**
     * The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly sortOrder?: AuditV2APIListAuditEventsSortOrderEnum

    /**
     * Whether to include the event body (full JSON payload b64 encoded string) for each returned event. When true, the effective page limit is capped at 25 due to payload sizes.
     * @type {boolean}
     * @memberof AuditV2APIApiAuditV2APIListAuditEvents
     */
    readonly includeBody?: boolean
}

/**
 * Request parameters for auditV2APIListEnterpriseAuditEvents operation in AuditV2APIApi.
 * @export
 * @interface AuditV2APIApiAuditV2APIListEnterpriseAuditEventsRequest
 */
export interface AuditV2APIApiAuditV2APIListEnterpriseAuditEventsRequest {
    /**
     * 
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly pageCursor?: string

    /**
     * The date and time to query from.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly fromDate?: string

    /**
     * The maximum date and time to query to. Defaults to now if from_date is set.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly toDate?: string

    /**
     * Plain-text search over audit event fields.
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly filterSearch?: string

    /**
     * List of audit event cluster IDs.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly filterClusters?: Array<string>

    /**
     * List of audit event domains, e.g. \&quot;platform\&quot;, \&quot;autoscaler\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly filterDomains?: Array<string>

    /**
     * List of audit event resources, e.g. \&quot;cluster\&quot;, \&quot;node\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly filterResources?: Array<string>

    /**
     * List of audit event actions, e.g. \&quot;created\&quot;, \&quot;deleted\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly filterActions?: Array<string>

    /**
     * List of audit event source services, e.g. \&quot;provisioner\&quot;, \&quot;woop\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly filterSources?: Array<string>

    /**
     * List of severity levels for audit events, e.g. \&quot;info\&quot;, \&quot;error\&quot;.
     * @type {Array<string>}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly filterSeverity?: Array<string>

    /**
     * Name of the field you want to sort
     * @type {string}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly sortField?: string

    /**
     * The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly sortOrder?: AuditV2APIListEnterpriseAuditEventsSortOrderEnum

    /**
     * Whether to include the event body (full JSON payload b64 encoded string) for each returned event. When true, the effective page limit is capped at 25 due to payload sizes.
     * @type {boolean}
     * @memberof AuditV2APIApiAuditV2APIListEnterpriseAuditEvents
     */
    readonly includeBody?: boolean
}

/**
 * AuditV2APIApi - object-oriented interface
 * @export
 * @class AuditV2APIApi
 * @extends {BaseAPI}
 */
export class AuditV2APIApi extends BaseAPI {
    /**
     * 
     * @summary GetAuditEvent returns a specific audit event.
     * @param {AuditV2APIApiAuditV2APIGetAuditEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditV2APIApi
     */
    public auditV2APIGetAuditEvent(requestParameters: AuditV2APIApiAuditV2APIGetAuditEventRequest, options?: RawAxiosRequestConfig) {
        return AuditV2APIApiFp(this.configuration).auditV2APIGetAuditEvent(requestParameters.id, requestParameters.recordedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetAuditHistogram returns a histogram of audit events bucketed by time and grouped by severity.
     * @param {AuditV2APIApiAuditV2APIGetAuditHistogramRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditV2APIApi
     */
    public auditV2APIGetAuditHistogram(requestParameters: AuditV2APIApiAuditV2APIGetAuditHistogramRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditV2APIApiFp(this.configuration).auditV2APIGetAuditHistogram(requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, requestParameters.numBuckets, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetAuditStats returns statistics for audit events matching the criteria set by filter.
     * @param {AuditV2APIApiAuditV2APIGetAuditStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditV2APIApi
     */
    public auditV2APIGetAuditStats(requestParameters: AuditV2APIApiAuditV2APIGetAuditStatsRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditV2APIApiFp(this.configuration).auditV2APIGetAuditStats(requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetEnterpriseAuditEvent returns a specific audit event within the enterprise organization, including events from its child organizations.
     * @param {AuditV2APIApiAuditV2APIGetEnterpriseAuditEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditV2APIApi
     */
    public auditV2APIGetEnterpriseAuditEvent(requestParameters: AuditV2APIApiAuditV2APIGetEnterpriseAuditEventRequest, options?: RawAxiosRequestConfig) {
        return AuditV2APIApiFp(this.configuration).auditV2APIGetEnterpriseAuditEvent(requestParameters.id, requestParameters.recordedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetEnterpriseAuditHistogram returns a histogram of audit events for the enterprise organization, including events from its child organizations.
     * @param {AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogramRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditV2APIApi
     */
    public auditV2APIGetEnterpriseAuditHistogram(requestParameters: AuditV2APIApiAuditV2APIGetEnterpriseAuditHistogramRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditV2APIApiFp(this.configuration).auditV2APIGetEnterpriseAuditHistogram(requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, requestParameters.numBuckets, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetEnterpriseAuditStats returns statistics for audit events for the enterprise organization, including events from its child organizations.
     * @param {AuditV2APIApiAuditV2APIGetEnterpriseAuditStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditV2APIApi
     */
    public auditV2APIGetEnterpriseAuditStats(requestParameters: AuditV2APIApiAuditV2APIGetEnterpriseAuditStatsRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditV2APIApiFp(this.configuration).auditV2APIGetEnterpriseAuditStats(requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetEnterpriseRelatedAuditEvents returns events related to the specified event within the enterprise organization, including events from its child organizations.
     * @param {AuditV2APIApiAuditV2APIGetEnterpriseRelatedAuditEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditV2APIApi
     */
    public auditV2APIGetEnterpriseRelatedAuditEvents(requestParameters: AuditV2APIApiAuditV2APIGetEnterpriseRelatedAuditEventsRequest, options?: RawAxiosRequestConfig) {
        return AuditV2APIApiFp(this.configuration).auditV2APIGetEnterpriseRelatedAuditEvents(requestParameters.id, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.recordedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetRelatedAuditEvents returns events related to the specified event.
     * @param {AuditV2APIApiAuditV2APIGetRelatedAuditEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditV2APIApi
     */
    public auditV2APIGetRelatedAuditEvents(requestParameters: AuditV2APIApiAuditV2APIGetRelatedAuditEventsRequest, options?: RawAxiosRequestConfig) {
        return AuditV2APIApiFp(this.configuration).auditV2APIGetRelatedAuditEvents(requestParameters.id, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.recordedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ListAuditEvents returns a list of audit events.
     * @param {AuditV2APIApiAuditV2APIListAuditEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditV2APIApi
     */
    public auditV2APIListAuditEvents(requestParameters: AuditV2APIApiAuditV2APIListAuditEventsRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditV2APIApiFp(this.configuration).auditV2APIListAuditEvents(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, requestParameters.sortField, requestParameters.sortOrder, requestParameters.includeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ListEnterpriseAuditEvents returns a list of audit events for the enterprise organization, including events from its child organizations.
     * @param {AuditV2APIApiAuditV2APIListEnterpriseAuditEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditV2APIApi
     */
    public auditV2APIListEnterpriseAuditEvents(requestParameters: AuditV2APIApiAuditV2APIListEnterpriseAuditEventsRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditV2APIApiFp(this.configuration).auditV2APIListEnterpriseAuditEvents(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.fromDate, requestParameters.toDate, requestParameters.filterSearch, requestParameters.filterClusters, requestParameters.filterDomains, requestParameters.filterResources, requestParameters.filterActions, requestParameters.filterSources, requestParameters.filterSeverity, requestParameters.sortField, requestParameters.sortOrder, requestParameters.includeBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AuditV2APIListAuditEventsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type AuditV2APIListAuditEventsSortOrderEnum = typeof AuditV2APIListAuditEventsSortOrderEnum[keyof typeof AuditV2APIListAuditEventsSortOrderEnum];
/**
 * @export
 */
export const AuditV2APIListEnterpriseAuditEventsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type AuditV2APIListEnterpriseAuditEventsSortOrderEnum = typeof AuditV2APIListEnterpriseAuditEventsSortOrderEnum[keyof typeof AuditV2APIListEnterpriseAuditEventsSortOrderEnum];
